import { Istituto } from ".";

export class Scuola {
    id?:string;
    codice?:string;
    nome?:string;
    idComune?:string;
    nomeComune?:string;
    istituto?: Istituto;
}